import { useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Hub } from "aws-amplify";
import { Button, Grid, Message, Header } from "semantic-ui-react";

// material
import { styled } from "@mui/material/styles";
import { Link, Container, Box } from "@mui/material";
import MyTextInput from "../components/common/form/MyTextInput";
import { signInStart } from "../redux/auth/auth.actions";

// components
import Page from "../components/Page";
import ClientMenuLeft from './common/ClientMenuLeft';
import DisplayCognitoError from "../components/common/DisplayCognitoError";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  display: "flex",
  minHeight: "100vh",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function AdminLoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentError } = useSelector((state) => state.authReducer);
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const loginHandle = (values) => {
    const payload = {
      email: values.email,
      password: values.password,
    };
    try {
      dispatch(signInStart(payload));

      Hub.listen("auth", (data) => {
        const { payload } = data;
        if (payload.event === "signIn") {
          navigate("/dashboard/app", { replace: true });
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <RootStyle title=" Administration des plaintes | Gestion des plaintes">
     <ClientMenuLeft />
      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Header as="h2" color="blue" textAlign="center">
              Administration des plaintes
            </Header>
          </Box>
          <Grid textAlign="center" verticalAlign="middle">
            <Grid.Column style={{ maxWidth: 450 }}>
              <DisplayCognitoError errorMessage={currentError} />
              <Formik
                initialValues={{ email: "", password: "" }}
                validationSchema={Yup.object({
                  email: Yup.string()
                    .required("Adresse e-mail est un champ obligatoire")
                    .email("Le champ e-mail n'est pas valide"),
                  password: Yup.string().required(
                    "Mot de passe est un champ obligatoire"
                  ),
                })}
                onSubmit={loginHandle}
              >
                <Form className="ui form">
                  <MyTextInput name="email" placeholder="Adresse e-mail" />

                  <div className="ui icon input">
                    <MyTextInput
                      name="password"
                      placeholder="Votre mot de passe"
                      type={passwordShown ? "text" : "password"}
                      size="60"
                    />
                    <i
                      aria-hidden="true"
                      onClick={togglePassword}
                      className="eye link icon"
                    ></i>
                  </div>
                  <Button
                    type="submit"
                    fluid
                    size="large"
                    color="blue"
                    content="Connexion"
                  />
                </Form>
              </Formik>
              <Message>
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/admin-register"
                >
                  S'inscrire
                </Link>
              </Message>
              <Message>
                <Link
                  underline="none"
                  variant="subtitle2"
                  component={RouterLink}
                  to="/admin-password-forgot"
                >
                 Mot de passe oublié ?
                </Link>
              </Message>
            </Grid.Column>
          </Grid>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
